// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"contractSimplified_addressItem__pJSWd","addressSection":"contractSimplified_addressSection__3cIJp"};